var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2141_9448)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: 4,
    width: 24,
    height: 16,
    rx: 3,
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: 8,
    width: 24,
    height: 3,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2141_9448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9995,
    height: 24,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.1a9d6f89568a2e7857dff950b165fd77.svg";
export { ForwardRef as ReactComponent };